<div class="panel widget" *ngIf="organisation && personId">
    <div class="panel-heading-flex">
        <div class="panel-title no-uppercase">Your Register Statuses</div>
        <div class="panel-content"></div>
        <div class="panel-buttons">
            <button
                class="btn btn-inline"
                (click)="showBody = !showBody"
                [tooltip]="showBody ? 'Hide' : 'Show'"
                placement="left"
            >
                <i *ngIf="showBody" class="fa-chevron-up fa no-border"></i>
                <i *ngIf="!showBody" class="fa-chevron-down fa no-border"></i>
            </button>
        </div>
    </div>
    <div
        *ngIf="showBody"
        class="panel-body bottom-buffer"
        @expandOnEnter
        @collapseOnLeave
    >
        <personnel-registers-status
            [managingOrganisationId]="organisation.id"
            [personId]="personId"
            [canEdit]="canEdit"
            [canAdminOrganisation]="canAdminOrganisation"
            [hasCurrency]="hasCurrency"
        ></personnel-registers-status>
    </div>
</div>
